// src/config.js

const getEnv = (key) => process.env[key];

export const getShopId = () => {
  return sessionStorage.getItem('shop_id') || getEnv('REACT_APP_SHOP_ID');
};

export const getShopCode = () => {
  return sessionStorage.getItem('shop_code') || getEnv('REACT_APP_SHOP_CODE');
};

export const getApiBaseUrl = () => {
  return sessionStorage.getItem('api_base_url') || getEnv('REACT_APP_API_BASE_URL');
};

// Optional: get all at once
export const getConfig = () => ({
  shop_id: getShopId(),
  shop_code: getShopCode(),
  api_base_url: getApiBaseUrl(),
});